import React, { useEffect, useState } from "react";
import "./productInDetails.scss";
import ProductDetails from "./productDetails/ProductDetails";
import ProductReview from "./productReview/ProductReview";
import BottomPart from "../../components/bottomPart/BottomPart";
import { useNavigate, useParams } from "react-router-dom";
import FourBreadcrumb from "../../components/breadcrumbs/FourBreadcrumb";
import productStore from "../../store/productStore";
import { CircularProgress } from "@mui/material";
import ReactPixel from "react-facebook-pixel";

// Icon
import SimilarProducts from "./similarProducts/SimilarProducts";
import ThreeBreadcrumb from "../../components/breadcrumbs/ThreeBreadcrumb";
import filterStore from "../../store/filterStore";
import ProductDetailsSkeleton from "./productDetails/ProductDetailsSkeleton";
import { ENV } from "constant";

const ProductInDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const ProductStore = productStore();
  const FilterStore = filterStore();
  const [data, setData] = useState();
  const [initScroll, setInitScroll] = useState(false);
  const [totalReview, setTotalReview] = useState(0);
  const [averageRating, setAverageRating] = useState(0);
  const [ratingLoading, setRatingLoading] = useState(true);

  useEffect(() => {
    init();
  }, [params.id]);

  const init = async () => {
    if (ProductStore.mProduct !== null) {
      await ProductStore.mProduct.filter((item) => {
        return item._id === params.id && setData(item);
      });
    } else {
      const product = await ProductStore.fetchOneProduct({ _id: params.id });
      if (product === null) {
        if (params.gender) {
          navigate(
            `/${params.gender}/${params.productCategory}/${params.productName}/${params.id}/error404`,
            { replace: true },
          );
        } else {
          navigate(
            `/${params.productCategory}/${params.productName}/${params.id}/error404`,
            { replace: true },
          );
        }
      }
      if (ENV === "production") {
        ReactPixel.track("ViewContent", {
          content_ids: [product._id],
          content_name: product.productName,
          content_type: "product",
          value: product.salePrice ? product.salePrice : product.regularPrice,
          currency: "INR",
        });
      }
      setData(product);
      await ProductStore.fetchAllProduct();
    }
    if (initScroll) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0 });
      setInitScroll(true);
    }
  };

  return (
    <div
      className="product-in-details"
      // style={{ overflowY: isOpenSidebar ? "hidden" : "scroll" }}
    >
      <div className="breadcrumb-container">
        {params.gender ? (
          <FourBreadcrumb
            firstName={params.gender}
            firstLink={`shop/${params.gender}`}
            secondName={params.productCategory}
            secondLink={`shop/${params.gender}/${params.productCategory}/${
              data && data.categoryID
            }`}
            activeName={params.productName}
          />
        ) : (
          <ThreeBreadcrumb
            firstName={params.productCategory}
            firstLink={`shop/category/${data && data.categoryID}/${
              params.productCategory
            }`}
            firstOnClick={() => FilterStore.resetFilters()}
            activeName={params.productName}
          />
        )}
      </div>
      {data ? (
        <div>
          <ProductDetails
            data={data}
            totalReview={totalReview}
            averageRating={averageRating}
            ratingLoading={ratingLoading}
          />
        </div>
      ) : (
        <div className="loader">
          {/* <CircularProgress /> */}
          <ProductDetailsSkeleton />
        </div>
      )}
      <ProductReview
        productID={params.id}
        totalReview={totalReview}
        setTotalReview={setTotalReview}
        averageRating={averageRating}
        setAverageRating={setAverageRating}
        ratingLoading={ratingLoading}
        setRatingLoading={setRatingLoading}
      />
      <SimilarProducts
        categoryID={data && data.categoryID}
        productID={data && data._id}
      />
    </div>
  );
};

export default ProductInDetails;
